import dayjs from 'dayjs';
import dayjsUtcPlugin from 'dayjs/plugin/utc';

dayjs.extend(dayjsUtcPlugin);

export default function unixDateFormatter(unixTime, format) {
  return dayjs.unix(unixTime).local().format(format);
}
